import type { EventOccurrenceViewModel } from '@trinnvis/dabih-api-client';
import { sortBy } from 'lodash';

export function toEventModel(occurrences: EventOccurrenceViewModel[]) {
  return {
    name: occurrences[0].name ?? '',
    eventOccurrences: sortBy(occurrences, ['date']),
  };
}
